<template>
    <div>
        <b-form>
            <b-form-row>
                <b-col>
                    <b-form-group>
                        <label>Payment Amount</label>
                        <h5 class="pt-1 pl-2">
                            {{ amountDisplay }}
                        </h5>
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group>
                        <label>Payment Date</label>
                        <b-form-datepicker
                            name="date"
                            required
                            :value="date === null ? Date() : date"
                            @input="emitFormUpdate($event, 'date')"
                        />
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group>
                        <label>AASIS Transaction Number</label>
                        <b-form-input
                            name="aasisNumber"
                            :value="aasisNumber"
                            @update="emitFormUpdate($event, 'aasisNumber')"
                        />
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group>
                        <label>Institution</label>
                        <b-select
                            name="applicant_id"
                            :value="applicantId"
                            @update="emitFormUpdate($event, 'applicantId')"
                        >
                            <slot name="institution_options">
                                <b-select-option :value="applicantId">
                                    Short Name ({{ applicantId }})
                                </b-select-option>
                            </slot>
                        </b-select>
                    </b-form-group>
                </b-col>
            </b-form-row>
            <b-form-row class="d-none">
                <b-col>
                    <b-form-group>
                        <label>Account Manager Comments</label>
                        <b-form-textarea
                            name="comment"
                            :rows="5"
                            :value="comment"
                            @update="emitFormUpdate($event, 'comment')"
                        />
                    </b-form-group>
                </b-col>
            </b-form-row>
        </b-form>

        <slot name="actions">
            <PaymentFormActions
                @cancel-payment="cancelPayment"
                @confirm-payment="confirmPayment"
            />
        </slot>
    </div>
</template>

<script>
import PaymentFormActions from './PaymentFormActions';
import { Arc } from '$Shared/@arc/vue-arc';
export default {
    name: 'PaymentForm',

    components: {
        PaymentFormActions
    },

    props: {
        amount: { type: [String, Number], required: true },
        date: { type: [String, Date], default: null },
        aasisNumber: { type: [String, Number], default: null },
        comment: { type: String, default: null },
        applicantId: { type: String, default: null },
        paymentId: { type: String, default: null },
    },

    computed: {
        isInvalidPayment() { return false; },
        isPaying() { return false; },
        amountDisplay() { return Arc.Money.asCurrency(this.amount); },
    },

    methods: {
        emitFormUpdate(value, key) {
            // this.$emit(`update:${key}`, value);
            // this.$emit(`update:payment`, { [key]: value });
            this.$emit(`update:payment`, { key, value });
        },

        cancelPayment($event) {
            this.$emit('cancel-payment', $event);
        },

        confirmPayment($event) {
            this.$emit('confirm-payment', $event);
        },
    }
};
</script>
